// eslint-disable-next-line no-shadow
export enum ChartType {
  pie = 'pie',
  bar = 'bar'
}
